export default class CourseTicket {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'validString',
    customerID: 'validString',
    tenantID: 'validString',
    userID: 'validString',
    courseID: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createCourseTicket(courseID, studentID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/course/' + courseID + '/student/' + studentID + '/ticket/new';
    return await req.exec();
  }
  async deleteCourseTicket(courseID, studentID, ticketID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/course/' + courseID + '/student/' + studentID + '/ticket/' + ticketID;
    return await req.exec();
  }
  async getCourseTicket(courseID, studentID, ticketID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/course/' + courseID + '/student/' + studentID + '/ticket/' + ticketID;
    return await req.exec();
  }
}
